<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "calendar",
  metaInfo: { title: "Kalender" },
  extends: View,

  mixins: [LoadSections(["calendar2025", "info"])],

  props: {
    id: {
      type: String,
      default: "calendar"
    }
  }
};
</script>
